<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
        style="opacity: 0.5;">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="container-fluid bg-breadcrumb">
        <div class="container text-center py-5" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInDown pmisputih" data-wow-delay="0.1s">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">STATUS PENGADAAN</span>
                <span v-else>PROCUREMENT STATUS</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-primary">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Status Pengadaan</span>
                    <span v-else>Procurement Status</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <!-- Contact Start -->
    <div class="container-fluid blog py-2">&nbsp;</div>
    <div class="container-fluid blog py-2">
        <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
            style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
            <div class="sub-style">
                <h1 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                    INFOGRAFIS STATUS PENGADAAN
                </h1>
                <h1 class="sub-title px-3 mb-0 labelpmis" v-else>
                    PROCUREMENT STATUS INFOGRAPHIC
                </h1>
            </div>
        </div>
        <div class="row g-4 justify-content-center">
            <div class="col-sm-10 wow fadeInUp" data-wow-delay="0.1s"
                style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                <Bar1ChartMonitoringProyek type="bar" :options="chartOptionsbar1" :series="seriesbar1" height="500">
                </Bar1ChartMonitoringProyek>
            </div>
            <div class="col-sm-10 wow fadeInUp" data-wow-delay="0.1s"
                style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                <Bar2ChartMonitoringProyek type="bar" :options="chartOptionsbar2" :series="seriesbar2" height="500">
                </Bar2ChartMonitoringProyek>
            </div>
            <div class="col-sm-10 wow fadeInUp" data-wow-delay="0.1s"
                style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                <Bar3ChartMonitoringProyek type="bar" :options="chartOptionsbar3" :series="seriesbar3" height="500">
                </Bar3ChartMonitoringProyek>
            </div>
        </div>
    </div>
    <div class="container-fluid blog py-2">
        <div class="container py-2">
            <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
                style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                <div class="sub-style">
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                        STATUS PENGADAAN
                    </h1>
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-else>
                        PROCUREMENT STATUS
                    </h1>
                </div>
            </div>
            <div class="col-sm-12">
                <div class="col-sm-12 text-center">
                    <a class="hitam">
                        <button type="button" class="btn btn-success btn-sm text-white lebar2" data-toggle="tooltip"
                            data-placement="left" title="Unduh excel.." @click="G_tableCSVTabel1('_QuickStatus_')">
                            <i class="fas fa-download"></i>
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                Unduh Data .xlsx
                            </span>
                            <span v-else>
                                Download Data .xlsx
                            </span>
                        </button>
                    </a>
                </div>
                <div class="col-sm-12 text-center">&nbsp;</div>
                <div class="col-sm-12 wow fadeInDown">
                    <div class="card cardputih collapsed-card">
                        <div class="card-header border-transparent" data-card-widget="collapse"
                            style="cursor: pointer;">
                            <label>
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Filter Kolom</span>
                                <span v-else>Column Filter</span>
                            </label>
                            <div class="card-tools">
                                <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                    <i class="fas fa-plus"></i>
                                </button>
                            </div>
                        </div>
                        <div class="card-body px-3">
                            <div class="row">
                                <div class="col-sm-2">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                            id="customCheckboxUnitPelaksana" value="optionUnitPelaksana" checked
                                            @click="showColumnUnitPelaksana = !showColumnUnitPelaksana">
                                        <label for="customCheckboxUnitPelaksana" class="custom-control-label">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                Unit Pelaksana
                                            </span>
                                            <span v-else>
                                                Implementation Unit
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                            id="customCheckboxKota" value="optionKota" checked
                                            @click="showColumnKota = !showColumnKota">
                                        <label for="customCheckboxKota" class="custom-control-label">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                Lokasi
                                            </span>
                                            <span v-else>
                                                Location
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                            id="customCheckboxJenisKegiatan" value="optionJenisKegiatan" checked
                                            @click="showColumnJenisKegiatan = !showColumnJenisKegiatan">
                                        <label for="customCheckboxJenisKegiatan" class="custom-control-label">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                Jenis Kegiatan
                                            </span>
                                            <span v-else>
                                                Type of activity
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                            id="customCheckboxOWP" value="optionOWP"
                                            @click="showColumnOWP = !showColumnOWP">
                                        <label for="customCheckboxOWP" class="custom-control-label">
                                            OWP</label>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                            id="customCheckboxRealisasiOWP" value="optionRealisasiOWP"
                                            @click="showColumnRealisasiOWP = !showColumnRealisasiOWP">
                                        <label for="customCheckboxRealisasiOWP" class="custom-control-label">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                Realisasi OWP
                                            </span>
                                            <span v-else>
                                                OWP realization
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                            id="customCheckboxAWP" value="optionAWP"
                                            @click="showColumnAWP = !showColumnAWP">
                                        <label for="customCheckboxAWP" class="custom-control-label">
                                            AWP</label>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                            id="customCheckboxRealisasiAWP" value="optionRealisasiAWP"
                                            @click="showColumnRealisasiAWP = !showColumnRealisasiAWP">
                                        <label for="customCheckboxRealisasiAWP" class="custom-control-label">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                Realisasi AWP
                                            </span>
                                            <span v-else>
                                                AWP realization
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                            id="customCheckboxDIPA" value="optionDIPA"
                                            @click="showColumnDIPA = !showColumnDIPA">
                                        <label for="customCheckboxDIPA" class="custom-control-label">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                DIPA
                                            </span>
                                            <span v-else>
                                                Table of Contents Implementation Budget
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                            id="customCheckboxRealisasiDIPA" value="optionRealisasiDIPA"
                                            @click="showColumnRealisasiDIPA = !showColumnRealisasiDIPA">
                                        <label for="customCheckboxRealisasiDIPA" class="custom-control-label">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                Realisasi DIPA
                                            </span>
                                            <span v-else>
                                                Table of Contents Implementation Budget realization
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                            id="customCheckboxTahunPersiapan" value="optioncustomCheckboxTahunPersiapan"
                                            @click="showColumnTahunPersiapan = !showColumnTahunPersiapan">
                                        <label for="customCheckboxTahunPersiapan" class="custom-control-label">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                Tahun Persiapan
                                            </span>
                                            <span v-else>
                                                Preparatory Year
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                            id="customCheckboxTahunMulai" value="optioncustomCheckboxTahunMulai"
                                            @click="showColumnTahunMulai = !showColumnTahunMulai">
                                        <label for="customCheckboxTahunMulai" class="custom-control-label">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                Tahun Mulai
                                            </span>
                                            <span v-else>
                                                Start Year
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                            id="customCheckboxTahunSelesai" value="optioncustomCheckboxTahunSelesai"
                                            @click="showColumnTahunSelesai = !showColumnTahunSelesai">
                                        <label for="customCheckboxTahunSelesai" class="custom-control-label">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                Tahun Selesai
                                            </span>
                                            <span v-else>
                                                Year Completed
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                            id="customCheckboxProgresPelaksanaan"
                                            value="optioncustomCheckboxProgresPelaksanaan" checked
                                            @click="showColumnProgresPelaksanaan = !showColumnProgresPelaksanaan">
                                        <label for="customCheckboxProgresPelaksanaan" class="custom-control-label">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                Progres Pelaksanaan
                                            </span>
                                            <span v-else>
                                                Implementation Progress
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                            id="customCheckboxProgresPersiapan"
                                            value="optioncustomCheckboxProgresPersiapan" checked
                                            @click="showColumnProgresPersiapan = !showColumnProgresPersiapan">
                                        <label for="customCheckboxProgresPersiapan" class="custom-control-label">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                Tahap Persiapan
                                            </span>
                                            <span v-else>
                                                Preparation Stage
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                            id="customCheckboxProgresPengadaan"
                                            value="optioncustomCheckboxProgresPengadaan" checked
                                            @click="showColumnProgresPengadaan = !showColumnProgresPengadaan">
                                        <label for="customCheckboxProgresPengadaan" class="custom-control-label">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                Tahap Pengadaan
                                            </span>
                                            <span v-else>
                                                Procurement Stage
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                            id="customCheckboxProgresPekerjaan"
                                            value="optioncustomCheckboxProgresPekerjaan" checked
                                            @click="showColumnProgresPekerjaan = !showColumnProgresPekerjaan">
                                        <label for="customCheckboxProgresPekerjaan" class="custom-control-label">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                Progres Pekerjaan
                                            </span>
                                            <span v-else>
                                                Work Progress
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 wow fadeInDown">
                    <div class="card cardputih collapsed-card">
                        <div class="card-header border-transparent" data-card-widget="collapse"
                            style="cursor: pointer;">
                            <label>
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Filter Data</span>
                                <span v-else>Data Filter</span>
                            </label>
                            <div class="card-tools">
                                <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                    <i class="fas fa-plus"></i>
                                </button>
                            </div>
                        </div>
                        <div class="card-body px-3">
                            <div class="row">
                                <div class="col-sm-2 text-center">
                                    <label>
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Unit Pelaksana
                                        </span>
                                        <span v-else>
                                            Implementation Unit
                                        </span>
                                    </label>
                                    <v-select :options="id_user" :reduce="(label) => label.code" label="label"
                                        v-model="defaultSelectedid_user" @update:modelValue="onid_userChange"
                                        style="background-color: #ffffff;color: black;"></v-select>
                                </div>
                                <div class="col-sm-2 text-center">
                                    <label>
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Lokasi
                                        </span>
                                        <span v-else>
                                            Location
                                        </span>
                                    </label>
                                    <v-select :options="lokasi" :reduce="(label) => label.code" label="label"
                                        v-model="defaultSelectedlokasi" @update:modelValue="onlokasiChange"
                                        style="background-color: #ffffff;color: black;"></v-select>
                                </div>
                                <div class="col-sm-2 text-center">
                                    <label>
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Jenis Kegiatan
                                        </span>
                                        <span v-else>
                                            Type of activity
                                        </span>
                                    </label>
                                    <v-select :options="jenispekerjaan" :reduce="(label) => label.code" label="label"
                                        v-model="defaultSelectedjenispekerjaan"
                                        @update:modelValue="onjenispekerjaanChange"
                                        style="background-color: #ffffff;color: black;"></v-select>
                                </div>
                                <div class="col-sm-2 text-center">
                                    <label>
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Tahun Persiapan
                                        </span>
                                        <span v-else>
                                            Preparatory Year
                                        </span>
                                    </label>
                                    <v-select :options="tahunpersiapan" :reduce="(label) => label.code" label="label"
                                        v-model="defaultSelectedtahunpersiapan"
                                        @update:modelValue="ontahunpersiapanChange"
                                        style="background-color: #ffffff;color: black;"></v-select>
                                </div>
                                <div class="col-sm-2 text-center">
                                    <label>
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Tahun Kontrak
                                        </span>
                                        <span v-else>
                                            Contract Year
                                        </span>
                                    </label>
                                    <v-select :options="tahunmulai" :reduce="(label) => label.code" label="label"
                                        v-model="defaultSelectedtahunmulai" @update:modelValue="ontahunmulaiChange"
                                        style="background-color: #ffffff;color: black;"></v-select>
                                </div>
                                <div class="col-sm-2 text-center">
                                    <label>
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Tahun Selesai
                                        </span>
                                        <span v-else>
                                            Year Completed
                                        </span>
                                    </label>
                                    <v-select :options="tahunselesai" :reduce="(label) => label.code" label="label"
                                        v-model="defaultSelectedtahunselesai" @update:modelValue="ontahunselesaiChange"
                                        style="background-color: #ffffff;color: black;"></v-select>
                                </div>
                                <div class="col-sm-12">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-responsive table-wrapper">
                    <table class="table m-0" id="tabeldata" style="font-size: small;">
                        <thead>
                            <tr>
                                <th style="width: 50px;" rowspan="2">No</th>
                                <th style="width: 220px;" rowspan="2">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Nama Pekerjaan</span>
                                    <span v-else>Package Name</span>
                                </th>
                                <th style="width: 200px;" rowspan="2" v-if="showColumnUnitPelaksana">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Unit Pelaksana</span>
                                    <span v-else>Implementation Unit</span>
                                </th>
                                <th style="width: 200px;" rowspan="2" v-if="showColumnKota">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Lokasi</span>
                                    <span v-else>Location</span>
                                </th>
                                <th style="width: 200px;" rowspan="2" v-if="showColumnJenisKegiatan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Jenis Kegiatan</span>
                                    <span v-else>Type of activity</span>
                                </th>
                                <th style="width: 100px;" rowspan="2" v-if="showColumnOWP">OWP</th>
                                <th style="width: 100px;" rowspan="2" v-if="showColumnRealisasiOWP">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Realiasi Kumulatif Terhadap OWP (%)
                                    </span>
                                    <span v-else>Cumulative Realization of OWP (%)</span>
                                </th>
                                <th style="width: 100px;" rowspan="2" v-if="showColumnAWP">AWP</th>
                                <th style="width: 100px;" rowspan="2" v-if="showColumnRealisasiAWP">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Realiasi Kumulatif Terhadap AWP (%)
                                    </span>
                                    <span v-else>Cumulative Realization of AWP (%)</span>
                                </th>
                                <th style="width: 100px;" rowspan="2" v-if="showColumnDIPA">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        DIPA
                                    </span>
                                    <span v-else>DIPA</span>
                                </th>
                                <th style="width: 100px;" rowspan="2" v-if="showColumnRealisasiDIPA">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Realiasi Kumulatif Terhadap DIPA (%)
                                    </span>
                                    <span v-else>DIPA Realization
                                        (%)</span>
                                </th>
                                <th style="width: 200px;" rowspan="2" v-if="showColumnTahunPersiapan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Tahun Persiapan
                                    </span>
                                    <span v-else>Preparatory Year</span>
                                </th>
                                <th style="width: 200px;" rowspan="2" v-if="showColumnTahunMulai">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Tahun Mulai Kontrak
                                    </span>
                                    <span v-else>Contract Start Year</span>
                                </th>
                                <th style="width: 200px;" rowspan="2" v-if="showColumnTahunSelesai">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Tahun Selesai Kontrak
                                    </span>
                                    <span v-else>Contract Completion Year</span>
                                </th>
                                <th style="width: 100px;" colspan="2" v-if="showColumnProgresPelaksanaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Progres Tahapan
                                    </span>
                                    <span v-else>Stage Progression</span>
                                </th>
                                <th style="width: 150px;" colspan="3" v-if="showColumnProgresPersiapan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Persiapan Dokumen Pengadaan
                                    </span>
                                    <span v-else>Preparation of Procurement Documents</span>
                                </th>
                                <th style="width: 350px;" colspan="7" v-if="showColumnProgresPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Pengadaan
                                    </span>
                                    <span v-else>Procurement</span>
                                </th>
                                <th style="width: 100px;" rowspan="2" v-if="showColumnProgresPekerjaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Progres Pekerjaan (%)
                                    </span>
                                    <span v-else>Job Progress (%)</span>
                                </th>

                            </tr>
                            <tr>
                                <th style="width: 50px;" v-if="showColumnProgresPelaksanaan">Status</th>
                                <th style="width: 50px;" v-if="showColumnProgresPelaksanaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Progres Capaian Tahapan Pekerjaan (%)
                                    </span>
                                    <span v-else>Work Stage Achievement Progress (%)</span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProgresPersiapan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Persiapan
                                    </span>
                                    <span v-else>Preparation</span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProgresPersiapan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Pengajuan
                                    </span>
                                    <span v-else>Submission</span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProgresPersiapan">Review</th>
                                <th style="width: 50px;" v-if="showColumnProgresPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Penyampaian NOL untuk Procurement Plan
                                    </span>
                                    <span v-else>Submission of NOL for Procurement Plan</span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProgresPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Pengajuan KAK/Spesifikasi Teknis
                                    </span>
                                    <span v-else>Submission of TOR/Technical Specifications</span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProgresPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Pengajuan Bidding Document
                                    </span>
                                    <span v-else>Submission of Bidding Documents</span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProgresPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Pengumuman Lelang (upload)
                                    </span>
                                    <span v-else>Auction Announcement (upload)</span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProgresPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Evaluasi
                                    </span>
                                    <span v-else>Evaluation</span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProgresPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Pengumuman Pemenang
                                    </span>
                                    <span v-else>Letter Acceptance</span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProgresPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Tandatangan Kontrak
                                    </span>
                                    <span v-else>Sign Contract</span>
                                </th>
                            </tr>
                        </thead>
                        <template v-for="(datalist, urutlist) in datamaster" :key="urutlist">
                            <tbody>
                                <tr>
                                    <td class="text-center"
                                        :class="[datalist.Status_pekerjaan == 'Finished' ? datalist.classstatus1 : '', '']">
                                        {{ urutlist + 1 }}
                                    </td>
                                    <td class="text-justify"
                                        :class="[datalist.Status_pekerjaan == 'Finished' ? datalist.classstatus1 : '', '']">
                                        {{ datalist.Nama_Kegiatan }}
                                    </td>
                                    <td class="text-center" v-if="showColumnUnitPelaksana"
                                        :class="[datalist.Status_pekerjaan == 'Finished' ? datalist.classstatus1 : '', '']">
                                        {{ datalist.Name }}
                                    </td>
                                    <td class="text-center" v-if="showColumnKota"
                                        :class="[datalist.Status_pekerjaan == 'Finished' ? datalist.classstatus1 : '', '']">
                                        {{ datalist.Lokasi }}
                                    </td>
                                    <td class="text-center" v-if="showColumnJenisKegiatan"
                                        :class="[datalist.Status_pekerjaan == 'Finished' ? datalist.classstatus1 : '', '']">
                                        {{ datalist.Kategori }}
                                    </td>
                                    <td class="text-right" v-if="showColumnOWP"
                                        :class="[datalist.Status_pekerjaan == 'Finished' ? datalist.classstatus1 : '', '']">
                                        {{ G_numFormat(datalist.OWP) }}
                                    </td>
                                    <td class="text-center" v-if="showColumnRealisasiOWP" data-z="#,##0.00"
                                        :class="[datalist.Status_pekerjaan == 'Finished' ? datalist.classstatus1 : '', '']">
                                        <span v-if="datalist.OWP > 0">{{
                                            G_numKoma((datalist.NILAI_KEUANGAN / datalist.OWP) * 100) }}</span>
                                        <span v-else>{{ G_numKoma(0) }}</span>
                                    </td>
                                    <td class="text-right" v-if="showColumnAWP" data-z="#,##0.00"
                                        :class="[datalist.Status_pekerjaan == 'Finished' ? datalist.classstatus1 : '', '']">
                                        {{ G_numFormat(datalist.AWP) }}
                                    </td>
                                    <td class="text-center" v-if="showColumnRealisasiAWP" data-z="#,##0.00"
                                        :class="[datalist.Status_pekerjaan == 'Finished' ? datalist.classstatus1 : '', '']">
                                        <span v-if="datalist.AWP > 0">{{
                                            G_numKoma((datalist.NILAI_KEUANGAN / datalist.AWP) * 100) }}</span>
                                        <span v-else>{{ G_numKoma(0) }}</span>
                                    </td>
                                    <td class="text-right" v-if="showColumnDIPA" data-z="#,##0.00"
                                        :class="[datalist.Status_pekerjaan == 'Finished' ? datalist.classstatus1 : '', '']">
                                        {{ G_numFormat(datalist.DIPA) }}
                                    </td>
                                    <td class="text-center" v-if="showColumnRealisasiDIPA" data-z="#,##0.00"
                                        :class="[datalist.Status_pekerjaan == 'Finished' ? datalist.classstatus1 : '', '']">
                                        <span v-if="datalist.DIPA > 0">{{
                                            G_numKoma((datalist.NILAI_KEUANGAN / datalist.DIPA) * 100) }}</span>
                                        <span v-else>{{ G_numKoma(0) }}</span>
                                    </td>
                                    <td class="text-center" v-if="showColumnTahunPersiapan" data-z="#,##0"
                                        :class="[datalist.Status_pekerjaan == 'Finished' ? datalist.classstatus1 : '', '']">
                                        {{ datalist.TahunPersiapan }}
                                    </td>
                                    <td class="text-center" v-if="showColumnTahunMulai" data-z="#,##0"
                                        :class="[datalist.Status_pekerjaan == 'Finished' ? datalist.classstatus1 : '', '']">
                                        {{ datalist.TahunMulai }}
                                    </td>
                                    <td class="text-center" v-if="showColumnTahunSelesai" data-z="#,##0"
                                        :class="[datalist.Status_pekerjaan == 'Finished' ? datalist.classstatus1 : '', '']">
                                        {{ datalist.TahunSelesai }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProgresPelaksanaan" data-z="#,##0.00"
                                        :class="[datalist.Status_pekerjaan == 'Finished' ? datalist.classstatus1 : '', '']">
                                        {{ datalist.Status_pekerjaan }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProgresPelaksanaan"
                                        :data-v="datalist.persentahapannya" data-z="#,##0.00"
                                        :class="[datalist.Status_pekerjaan == 'Finished' ? datalist.classstatus1 : '', '']">
                                        {{ G_numKoma(datalist.persentahapannya) }}
                                    </td>
                                    <td class="text-center" :class="datalist.classstatus1"
                                        v-if="showColumnProgresPersiapan">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            {{ datalist.Status_1 }}
                                        </span>
                                        <span v-else>
                                            {{ datalist.Status_1_eng }}
                                        </span>
                                    </td>
                                    <td class="text-center" :class="datalist.classstatus2"
                                        v-if="showColumnProgresPersiapan">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            {{ datalist.Status_2 }}
                                        </span>
                                        <span v-else>
                                            {{ datalist.Status_2_eng }}
                                        </span>
                                    </td>
                                    <td class="text-center" :class="datalist.classstatus3"
                                        v-if="showColumnProgresPersiapan">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            {{ datalist.Status_3 }}
                                        </span>
                                        <span v-else>
                                            {{ datalist.Status_3_eng }}
                                        </span>
                                    </td>
                                    <td class="text-center" :class="datalist.classstatus4"
                                        v-if="showColumnProgresPengadaan">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            {{ datalist.Status_4 }}
                                        </span>
                                        <span v-else>
                                            {{ datalist.Status_4_eng }}
                                        </span>
                                    </td>
                                    <td class="text-center" :class="datalist.classstatus5"
                                        v-if="showColumnProgresPengadaan">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            {{ datalist.Status_5 }}
                                        </span>
                                        <span v-else>
                                            {{ datalist.Status_5_eng }}
                                        </span>
                                    </td>
                                    <td class="text-center" :class="datalist.classstatus6"
                                        v-if="showColumnProgresPengadaan">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            {{ datalist.Status_6 }}
                                        </span>
                                        <span v-else>
                                            {{ datalist.Status_6_eng }}
                                        </span>
                                    </td>
                                    <td class="text-center" :class="datalist.classstatus7"
                                        v-if="showColumnProgresPengadaan">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            {{ datalist.Status_7 }}
                                        </span>
                                        <span v-else>
                                            {{ datalist.Status_7_eng }}
                                        </span>
                                    </td>
                                    <td class="text-center" :class="datalist.classstatus8"
                                        v-if="showColumnProgresPengadaan">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            {{ datalist.Status_8 }}
                                        </span>
                                        <span v-else>
                                            {{ datalist.Status_8_eng }}
                                        </span>
                                    </td>
                                    <td class="text-center" :class="datalist.classstatus9"
                                        v-if="showColumnProgresPengadaan">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            {{ datalist.Status_9 }}
                                        </span>
                                        <span v-else>
                                            {{ datalist.Status_9_eng }}
                                        </span>
                                    </td>
                                    <td class="text-center" :class="datalist.classstatus10"
                                        v-if="showColumnProgresPengadaan">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            {{ datalist.Status_10 }}
                                        </span>
                                        <span v-else>
                                            {{ datalist.Status_10_eng }}
                                        </span>
                                    </td>
                                    <td class="text-center" v-if="showColumnProgresPekerjaan" :data-v="datalist.PROGRES"
                                        data-z="#,##0.00"
                                        :class="[datalist.Status_pekerjaan == 'Finished' ? datalist.classstatus1 : '', '']">
                                        {{ G_numKoma(datalist.PROGRES) }}
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                        <tbody v-if="(datapesan == 'data kosong')">
                            <tr>
                                Data masih kosong
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <div class="container-fluid blog py-2">
        <div class="container py-2">
            <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
                style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                <div class="sub-style">
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                        QUICK STATUS PENGADAAN PER LOKASI
                    </h1>
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-else>
                        QUICK PROCUREMENT STATUS PER LOCATION
                    </h1>
                </div>
            </div>
            <div class="col-sm-12">
                <div class="col-sm-12 text-center">
                    <a class="hitam">
                        <button type="button" class="btn btn-success btn-sm text-white lebar2" data-toggle="tooltip"
                            data-placement="left" title="Unduh excel.."
                            @click="G_tableCSVTabel2('_QuickStatusRekapKota_')">
                            <i class="fas fa-download"></i>
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                Unduh Data .xlsx
                            </span>
                            <span v-else>
                                Download Data .xlsx
                            </span>
                        </button>
                    </a>
                </div>
                <div class="col-sm-12 text-center">&nbsp;</div>
                <div class="col-sm-12 wow fadeInDown">
                    <div class="card cardputih collapsed-card">
                        <div class="card-header border-transparent" data-card-widget="collapse"
                            style="cursor: pointer;">
                            <label>
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Filter Kolom</span>
                                <span v-else>Column Filter</span>
                            </label>
                            <div class="card-tools">
                                <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                    <i class="fas fa-plus"></i>
                                </button>
                            </div>
                        </div>
                        <div class="card-body px-3">
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                            id="customCheckboxJumlah" value="optionJumlah" checked
                                            @click="showColumnJumlah = !showColumnJumlah">
                                        <label for="customCheckboxJumlah" class="custom-control-label">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                Jumlah
                                            </span>
                                            <span v-else>
                                                Amount
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                            id="customCheckboxProsesPersiapan" value="optionProsesPersiapan" checked
                                            @click="showColumnProsesPersiapan = !showColumnProsesPersiapan">
                                        <label for="customCheckboxProsesPersiapan" class="custom-control-label">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                Proses Persiapan
                                            </span>
                                            <span v-else>
                                                Preparation Process
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                            id="customCheckboxProsesPengadaan" value="optionProsesPengadaan" checked
                                            @click="showColumnProsesPengadaan = !showColumnProsesPengadaan">
                                        <label for="customCheckboxProsesPengadaan" class="custom-control-label">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                Proses Pengadaan
                                            </span>
                                            <span v-else>
                                                Procurement Process
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                            id="customCheckboxProgresPelaksanaan2" value="optionProgresPelaksanaan2"
                                            checked
                                            @click="showColumnProgresPelaksanaan2 = !showColumnProgresPelaksanaan2">
                                        <label for="customCheckboxProgresPelaksanaan2" class="custom-control-label">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                Progres Pelaksanaan
                                            </span>
                                            <span v-else>
                                                Implementation Progress
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 wow fadeInDown">
                    <div class="card cardputih collapsed-card">
                        <div class="card-header border-transparent" data-card-widget="collapse"
                            style="cursor: pointer;">
                            <label>
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Filter Data</span>
                                <span v-else>Data Filter</span>
                            </label>
                            <div class="card-tools">
                                <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                    <i class="fas fa-plus"></i>
                                </button>
                            </div>
                        </div>
                        <div class="card-body px-3">
                            <div class="row">
                                <div class="col-sm-3 text-center">
                                    <label>
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Unit Pelaksana</span>
                                        <span v-else>Implementation Unit</span>
                                    </label>
                                    <v-select :options="id_user2" :reduce="(label) => label.code" label="label"
                                        v-model="defaultSelectedid_user2" @update:modelValue="onid_user2Change"
                                        style="background-color: #ffffff;color: black;"></v-select>
                                </div>
                                <div class="col-sm-3 text-center">
                                    <label>
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Lokasi</span>
                                        <span v-else>Location</span>
                                    </label>
                                    <v-select :options="lokasi2" :reduce="(label) => label.code" label="label"
                                        v-model="defaultSelectedlokasi2" @update:modelValue="onlokasi2Change"
                                        style="background-color: #ffffff;color: black;"></v-select>
                                </div>
                                <div class="col-sm-3 text-center">
                                    <label>
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Jenis Pekerjaan</span>
                                        <span v-else>Type of work</span>
                                    </label>
                                    <v-select :options="jenispekerjaan2" :reduce="(label) => label.code" label="label"
                                        v-model="defaultSelectedjenispekerjaan2"
                                        @update:modelValue="onjenispekerjaan2Change"
                                        style="background-color: #ffffff;color: black;"></v-select>
                                </div>
                                <div class="col-sm-3 text-center">
                                    <label>
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Tahun</span>
                                        <span v-else>Years</span>
                                    </label>
                                    <v-select :options="tahunmulai2" :reduce="(label) => label.code" label="label"
                                        v-model="defaultSelectedtahunmulai2" @update:modelValue="ontahunmulai2Change"
                                        style="background-color: #ffffff;color: black;"></v-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 text-center">&nbsp;</div>
                <div class="table-responsive table-wrapper">
                    <table class="table m-0" id="tabeldata2" style="font-size: small;">
                        <thead>
                            <tr>
                                <th style="width: 50px;" rowspan="3">No</th>
                                <th style="width: 100px;" rowspan="3">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Lokasi
                                    </span>
                                    <span v-else>Location</span>
                                </th>
                                <th style="width: 50px;" rowspan="3" v-if="showColumnJumlah">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Jumlah
                                    </span>
                                    <span v-else>Amount</span>
                                </th>
                                <th style="width: 450px;" colspan="9" v-if="showColumnProsesPersiapan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Persiapan
                                    </span>
                                    <span v-else>Preparation</span>
                                </th>
                                <th style="width: 1050px;" colspan="21" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Pengadaan
                                    </span>
                                    <span v-else>Procurement</span>
                                </th>
                                <th style="width: 200px;" colspan="4" v-if="showColumnProgresPelaksanaan2">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Progres Pelaksanaan
                                    </span>
                                    <span v-else>Implementation Progress</span>
                                </th>
                            </tr>
                            <tr>
                                <th style="width: 150px;" colspan="3" v-if="showColumnProsesPersiapan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Jumlah Kegiatan Berdasarkan Penyiapan Dokumen Pengadaan
                                    </span>
                                    <span v-else>Number of Activities Based on Preparation of Procurement
                                        Documents</span>
                                </th>
                                <th style="width: 150px;" colspan="3" v-if="showColumnProsesPersiapan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Jumlah Kegiatan Berdasarkan Pengajuan Dokumen Pengadaan
                                    </span>
                                    <span v-else>Number of Activities Based on Submission of Procurement
                                        Documents</span>
                                </th>
                                <th style="width: 150px;" colspan="3" v-if="showColumnProsesPersiapan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Jumlah Kegiatan Berdasarkan Review Dokumen Pengadaan
                                    </span>
                                    <span v-else>Number of Activities Based on Review of Procurement Documents</span>
                                </th>
                                <th style="width: 150px;" colspan="3" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Jumlah Kegiatan Berdasarkan Penyampaian NOL untuk Procurement Plan
                                    </span>
                                    <span v-else>Number of Activities Based on Submission of NOL for Procurement
                                        Plan</span>
                                </th>
                                <th style="width: 150px;" colspan="3" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Jumlah Kegiatan Berdasarkan Pengajuan Pengajuan KAK/Spesifikasi Teknis
                                    </span>
                                    <span v-else>Number of Activities Based on Submission of TOR/Technical
                                        Specifications</span>
                                </th>
                                <th style="width: 150px;" colspan="3" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Jumlah Kegiatan Berdasarkan Pengajuan Bidding Document
                                    </span>
                                    <span v-else>Number of Activities Based on Bidding Document Submission</span>
                                </th>
                                <th style="width: 150px;" colspan="3" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Jumlah Kegiatan Berdasarkan Pengumuman Lelang
                                    </span>
                                    <span v-else>Number of Activities Based on Auction Announcement</span>
                                </th>
                                <th style="width: 150px;" colspan="3" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Jumlah Kegiatan Berdasarkan Evaluasi
                                    </span>
                                    <span v-else>Number of Activities Based on Evaluation</span>
                                </th>
                                <th style="width: 150px;" colspan="3" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Jumlah Kegiatan Berdasarkan Pengumuman Pemenang
                                    </span>
                                    <span v-else>Number of Activities Based on Letter Acceptance</span>
                                </th>
                                <th style="width: 150px;" colspan="3" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Jumlah Kegiatan Berdasarkan Tandatangan Kontrak
                                    </span>
                                    <span v-else>Number of Activities Based on Sign Contract</span>
                                </th>
                                <th style="width: 150px;" colspan="3" v-if="showColumnProgresPelaksanaan2">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Jumlah Kegiatan Berdasarkan Progres Pelaksanaan
                                    </span>
                                    <span v-else>Number of Activities Based on Implementation Progress</span>
                                </th>
                                <th style="width: 50px;" rowspan="2" v-if="showColumnProgresPelaksanaan2">Progres (%)
                                </th>
                            </tr>
                            <tr>
                                <th style="width: 50px;" v-if="showColumnProsesPersiapan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Belum
                                    </span>
                                    <span v-else>
                                        Not yet
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPersiapan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Proses
                                    </span>
                                    <span v-else>
                                        Process
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPersiapan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Selesai
                                    </span>
                                    <span v-else>
                                        Finished
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPersiapan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Belum
                                    </span>
                                    <span v-else>
                                        Not yet
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPersiapan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Proses
                                    </span>
                                    <span v-else>
                                        Process
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPersiapan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Selesai
                                    </span>
                                    <span v-else>
                                        Finished
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPersiapan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Belum
                                    </span>
                                    <span v-else>
                                        Not yet
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPersiapan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Proses
                                    </span>
                                    <span v-else>
                                        Process
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPersiapan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Selesai
                                    </span>
                                    <span v-else>
                                        Finished
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Belum
                                    </span>
                                    <span v-else>
                                        Not yet
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Proses
                                    </span>
                                    <span v-else>
                                        Process
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Selesai
                                    </span>
                                    <span v-else>
                                        Finished
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Belum
                                    </span>
                                    <span v-else>
                                        Not yet
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Proses
                                    </span>
                                    <span v-else>
                                        Process
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Selesai
                                    </span>
                                    <span v-else>
                                        Finished
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Belum
                                    </span>
                                    <span v-else>
                                        Not yet
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Proses
                                    </span>
                                    <span v-else>
                                        Process
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Selesai
                                    </span>
                                    <span v-else>
                                        Finished
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Belum
                                    </span>
                                    <span v-else>
                                        Not yet
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Proses
                                    </span>
                                    <span v-else>
                                        Process
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Selesai
                                    </span>
                                    <span v-else>
                                        Finished
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Belum
                                    </span>
                                    <span v-else>
                                        Not yet
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Proses
                                    </span>
                                    <span v-else>
                                        Process
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Selesai
                                    </span>
                                    <span v-else>
                                        Finished
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Belum
                                    </span>
                                    <span v-else>
                                        Not yet
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Proses
                                    </span>
                                    <span v-else>
                                        Process
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Selesai
                                    </span>
                                    <span v-else>
                                        Finished
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Belum
                                    </span>
                                    <span v-else>
                                        Not yet
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Proses
                                    </span>
                                    <span v-else>
                                        Process
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProsesPengadaan">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Selesai
                                    </span>
                                    <span v-else>
                                        Finished
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProgresPelaksanaan2">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Belum
                                    </span>
                                    <span v-else>
                                        Not yet
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProgresPelaksanaan2">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Proses
                                    </span>
                                    <span v-else>
                                        Process
                                    </span>
                                </th>
                                <th style="width: 50px;" v-if="showColumnProgresPelaksanaan2">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Selesai
                                    </span>
                                    <span v-else>
                                        Finished
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <template v-for="(datalist, urutlist) in datamasterkota" :key="urutlist">
                            <tbody>
                                <tr>
                                    <td class="text-center">
                                        {{ urutlist + 1 }}
                                    </td>
                                    <td class="text-justify">
                                        {{ datalist.Lokasi }}
                                    </td>
                                    <td class="text-center" v-if="showColumnJumlah" data-z="#,##0">
                                        {{ datalist.Jumlah }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPersiapan" data-z="#,##0">
                                        {{ datalist.belumpersiapan }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPersiapan" data-z="#,##0">
                                        {{ datalist.prosespersiapan }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPersiapan" data-z="#,##0">
                                        {{ datalist.sudahpersiapan }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPersiapan" data-z="#,##0">
                                        {{ datalist.belumpengajuan }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPersiapan" data-z="#,##0">
                                        {{ datalist.prosespengajuan }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPersiapan" data-z="#,##0">
                                        {{ datalist.sudahpengajuan }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPersiapan" data-z="#,##0">
                                        {{ datalist.belumreview }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPersiapan" data-z="#,##0">
                                        {{ datalist.prosesreview }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPersiapan" data-z="#,##0">
                                        {{ datalist.sudahreview }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPengadaan" data-z="#,##0">
                                        {{ datalist.belumpenyampaiannolprocurement }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPengadaan" data-z="#,##0">
                                        {{ datalist.prosespenyampaiannolprocurement }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPengadaan" data-z="#,##0">
                                        {{ datalist.sudahpenyampaiannolprocurement }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPengadaan" data-z="#,##0">
                                        {{ datalist.belumpengajuanprocurement }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPengadaan" data-z="#,##0">
                                        {{ datalist.prosespengajuanprocurement }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPengadaan" data-z="#,##0">
                                        {{ datalist.sudahpengajuanprocurement }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPengadaan" data-z="#,##0">
                                        {{ datalist.belumpengajuanbiddingdocument }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPengadaan" data-z="#,##0">
                                        {{ datalist.prosespengajuanbiddingdocument }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPengadaan" data-z="#,##0">
                                        {{ datalist.sudahpengajuanbiddingdocument }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPengadaan" data-z="#,##0">
                                        {{ datalist.belumpengumumanlelang }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPengadaan" data-z="#,##0">
                                        {{ datalist.prosespengumumanlelang }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPengadaan" data-z="#,##0">
                                        {{ datalist.sudahpengumumanlelang }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPengadaan" data-z="#,##0">
                                        {{ datalist.belumevaluasilelang }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPengadaan" data-z="#,##0">
                                        {{ datalist.prosesevaluasilelang }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPengadaan" data-z="#,##0">
                                        {{ datalist.sudahevaluasilelang }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPengadaan" data-z="#,##0">
                                        {{ datalist.belumpengumumanpemenang }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPengadaan" data-z="#,##0">
                                        {{ datalist.prosespengumumanpemenang }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPengadaan" data-z="#,##0">
                                        {{ datalist.sudahpengumumanpemenang }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPengadaan" data-z="#,##0">
                                        {{ datalist.belumttdkontrak }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPengadaan" data-z="#,##0">
                                        {{ datalist.prosesttdkontrak }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProsesPengadaan" data-z="#,##0">
                                        {{ datalist.sudahttdkontrak }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProgresPelaksanaan2" data-z="#,##0">
                                        {{ datalist.belumpelaksanaan }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProgresPelaksanaan2" data-z="#,##0">
                                        {{ datalist.prosespelaksanaan }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProgresPelaksanaan2" data-z="#,##0">
                                        {{ datalist.sudahpelaksanaan }}
                                    </td>
                                    <td class="text-center" v-if="showColumnProgresPelaksanaan2" data-z="#,##0.00"
                                        :data-v="datalist.PROGRES">
                                        {{ G_numKoma(datalist.PROGRES) }}
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                        <tbody v-if="(datapesan == 'data kosong')">
                            <tr>
                                Data masih kosong
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <!-- Contact End -->

    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import vSelect from 'vue-select';
import xlsx from 'xlsx/dist/xlsx.full.min';
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "OpenSans-Regular, Arial, sans-serif" };
import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal, vSelect, Bar1ChartMonitoringProyek: VueApexCharts, Bar2ChartMonitoringProyek: VueApexCharts
        , Bar3ChartMonitoringProyek: VueApexCharts
    },
    data() {
        return {
            iduser: JSON.parse(localStorage.getItem("usistem")),
            halamanloading: true,
            showColumnUnitPelaksana: true,
            showColumnKota: true,
            showColumnJenisKegiatan: true,
            showColumnOWP: false,
            showColumnRealisasiOWP: false,
            showColumnAWP: false,
            showColumnRealisasiAWP: false,
            showColumnDIPA: false,
            showColumnRealisasiDIPA: false,
            showColumnTahunPersiapan: false,
            showColumnTahunMulai: false,
            showColumnTahunSelesai: false,
            showColumnProgresPelaksanaan: true,
            showColumnProgresPersiapan: true,
            showColumnProgresPengadaan: true,
            showColumnProgresPekerjaan: true,
            showColumnJumlah: true,
            showColumnProsesPersiapan: true,
            showColumnProsesPengadaan: true,
            showColumnProgresPelaksanaan2: true,
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            halamanloading: true,
            datapesan: '',
            datamaster: [],
            datamasterkota: [],
            carikata: '',
            id_user: [],
            dataid_user: [],
            defaultSelectedid_user: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedid_user: '',


            id_user2: [],
            dataid_user2: [],
            defaultSelectedid_user2: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedid_user2: '',

            lokasi: [],
            datalokasi: [],
            defaultSelectedlokasi: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedlokasi: '',

            lokasi2: [],
            datalokasi2: [],
            defaultSelectedlokasi2: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedlokasi2: '',

            jenispekerjaan: [],
            datajenispekerjaan: [],
            defaultSelectedjenispekerjaan: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedjenispekerjaan: '',

            jenispekerjaan2: [],
            datajenispekerjaan2: [],
            defaultSelectedjenispekerjaan2: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedjenispekerjaan2: '',

            tahunmulai: [],
            datatahunmulai: [],
            defaultSelectedtahunmulai: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedtahunmulai: '',

            tahunmulai2: [],
            datatahunmulai2: [],
            defaultSelectedtahunmulai2: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedtahunmulai2: '',

            tahunselesai: [],
            datatahunselesai: [],
            defaultSelectedtahunselesai: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedtahunselesai: '',

            tahunpersiapan: [],
            datatahunpersiapan: [],
            defaultSelectedtahunpersiapan: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedtahunpersiapan: '',

            datatahun: [],

            seriesbar1: [],
            chartOptionsbar1: {
                title: {
                    text: 'Jumlah Total Kegiatan Dan Tahapan Pekerjaan Per Lokasi',
                    align: 'center'
                },
                chart: {
                    type: 'bar',
                    height: 350,
                    toolbar: {
                        show: true
                    }
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            position: 'top', // top, center, bottom
                        },
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded'
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val;
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                    }
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: [],
                },
                yaxis: {
                    title: {
                        text: 'Jumlah Kegiatan'
                    }
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " Kegiatan"
                        }
                    }
                }
            },

            seriesbar2: [],
            chartOptionsbar2: {
                title: {
                    text: 'Jumlah Total Kegiatan Dan Tahapan Persiapan Pekerjaan Per Lokasi',
                    align: 'center'
                },
                chart: {
                    type: 'bar',
                    height: 350,
                    toolbar: {
                        show: true
                    }
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            position: 'top', // top, center, bottom
                        },
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded'
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val;
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                    }
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: [],
                },
                yaxis: {
                    title: {
                        text: 'Jumlah Kegiatan'
                    }
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " Kegiatan"
                        }
                    }
                }
            },

            seriesbar3: [],
            chartOptionsbar3: {
                title: {
                    text: 'Jumlah Total Kegiatan Dan Tahapan Pengadaan Pekerjaan Per Lokasi',
                    align: 'center'
                },
                chart: {
                    type: 'bar',
                    height: 350,
                    toolbar: {
                        show: true
                    }
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            position: 'top', // top, center, bottom
                        },
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded'
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val;
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                    }
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: [],
                },
                yaxis: {
                    title: {
                        text: 'Jumlah Kegiatan'
                    }
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " Kegiatan"
                        }
                    }
                },
                colors: ['#00BFFF', '#FF8C00', '#B8860B', '#006400', '#BDB76B', '#8B0000', '#FF69B4', '#CD5C5C', '#F0E68C', '#7CFC00'],
            },


            ekportexcel: [],
            ekportexcel1: [],
            ekportexcel2: [],
            project_id: process.env.VUE_APP_PROJECT_ID,
        };
    },
    methods: {
        async G_tableCSVTabel1(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_' + namefile + '.xlsx';
            var paramurl = "";
            if ((this.iduser == null) || (this.iduser == 'null') || (this.iduser == '') || (this.iduser == undefined)) {
                paramurl = "parastapainnovationcetakprocpublik-Status?random=" + random + "&project_id=" + this.project_id
                    + "&showColumnUnitPelaksana=" + this.showColumnUnitPelaksana + "&showColumnKota=" + this.showColumnKota + "&showColumnJenisKegiatan=" + this.showColumnJenisKegiatan
                    + "&showColumnOWP=" + this.showColumnOWP + "&showColumnRealisasiOWP=" + this.showColumnRealisasiOWP + "&showColumnAWP=" + this.showColumnAWP
                    + "&showColumnRealisasiAWP=" + this.showColumnRealisasiAWP + "&showColumnDIPA=" + this.showColumnDIPA + "&showColumnRealisasiDIPA=" + this.showColumnRealisasiDIPA
                    + "&showColumnTahunPersiapan=" + this.showColumnTahunPersiapan + "&showColumnTahunMulai=" + this.showColumnTahunMulai + "&showColumnTahunSelesai=" + this.showColumnTahunSelesai
                    + "&showColumnProgresPelaksanaan=" + this.showColumnProgresPelaksanaan + "&showColumnProgresPersiapan=" + this.showColumnProgresPersiapan + "&showColumnProgresPengadaan=" + this.showColumnProgresPengadaan
                    + "&showColumnProgresPekerjaan=" + this.showColumnProgresPekerjaan + "&id_user=" + this.selectedid_user + "&id_lokasi=" + this.selectedlokasi + "&jenispekerjaan=" + this.selectedjenispekerjaan + "&tahunmulai=" + this.selectedtahunmulai + "&tahunselesai=" + this.selectedtahunselesai + "&tahunpersiapan=" + this.selectedtahunpersiapan;
            }
            else {
                paramurl = "parastapainnovationcetakprocadmin-Status?random=" + random + "&project_id=" + this.project_id
                    + "&showColumnUnitPelaksana=" + this.showColumnUnitPelaksana + "&showColumnKota=" + this.showColumnKota + "&showColumnJenisKegiatan=" + this.showColumnJenisKegiatan
                    + "&showColumnOWP=" + this.showColumnOWP + "&showColumnRealisasiOWP=" + this.showColumnRealisasiOWP + "&showColumnAWP=" + this.showColumnAWP
                    + "&showColumnRealisasiAWP=" + this.showColumnRealisasiAWP + "&showColumnDIPA=" + this.showColumnDIPA + "&showColumnRealisasiDIPA=" + this.showColumnRealisasiDIPA
                    + "&showColumnTahunPersiapan=" + this.showColumnTahunPersiapan + "&showColumnTahunMulai=" + this.showColumnTahunMulai + "&showColumnTahunSelesai=" + this.showColumnTahunSelesai
                    + "&showColumnProgresPelaksanaan=" + this.showColumnProgresPelaksanaan + "&showColumnProgresPersiapan=" + this.showColumnProgresPersiapan + "&showColumnProgresPengadaan=" + this.showColumnProgresPengadaan + "&id_user=" + this.selectedid_user + "&id_lokasi=" + this.selectedlokasi + "&jenispekerjaan=" + this.selectedjenispekerjaan + "&tahunmulai=" + this.selectedtahunmulai + "&tahunselesai=" + this.selectedtahunselesai + "&tahunpersiapan=" + this.selectedtahunpersiapan
            }
            await mainAPI5.get(paramurl).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async G_tableCSVTabel2(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_' + namefile + '.xlsx';
            var paramurl = "";
            paramurl = "parastapainnovationcetakprocpublik-Kota?random=" + random + "&project_id=" + this.project_id
                + "&showColumnJumlah=" + this.showColumnJumlah + "&showColumnProsesPersiapan=" + this.showColumnProsesPersiapan + "&showColumnProsesPengadaan=" + this.showColumnProsesPengadaan
                + "&showColumnProgresPelaksanaan2=" + this.showColumnProgresPelaksanaan2 + "&id_user=" + this.selectedid_user2 + "&id_lokasi=" + this.selectedlokasi2 + "&jenispekerjaan=" + this.selectedjenispekerjaan2 + "&tahunmulai=" + this.selectedtahunmulai2;
            await mainAPI5.get(paramurl).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async ambildatareff() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI5.get("parastapainnovationreffmonitoring-UserProject?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataid_user = [];
                        this.id_user = [];
                        this.dataid_user = Response.data.content.data;
                        this.dataid_user.forEach((item) => {
                            this.id_user.push({
                                label: item.nama_satker,
                                code: this.dataid_user.indexOf(item) + 1,
                                tag: item.user_id,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedid_user = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.id_user.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedid_user = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.id_user.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        this.halamanloading = true;
                        this.dataid_user2 = [];
                        this.id_user2 = [];
                        this.dataid_user2 = Response.data.content.data;
                        this.dataid_user2.forEach((item) => {
                            this.id_user2.push({
                                label: item.nama_satker,
                                code: this.dataid_user2.indexOf(item) + 1,
                                tag: item.user_id,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedid_user2 = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.id_user2.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedid_user2 = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.id_user2.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        this.halamanloading = false;
                    }

                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
            this.halamanloading = true;
            await mainAPI5.get("parastapainnovationreffmonitoring-Lokasi?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datalokasi = [];
                        this.lokasi = [];
                        this.datalokasi = Response.data.content.data;
                        this.datalokasi.forEach((item) => {
                            this.lokasi.push({
                                label: item.nama,
                                code: this.datalokasi.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedlokasi = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.lokasi.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedlokasi = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.lokasi.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }


                        this.datalokasi2 = [];
                        this.lokasi2 = [];
                        this.datalokasi2 = Response.data.content.data;
                        this.datalokasi2.forEach((item) => {
                            this.lokasi2.push({
                                label: item.nama,
                                code: this.datalokasi2.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedlokasi2 = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.lokasi2.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedlokasi2 = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.lokasi2.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        this.halamanloading = false;
                    }

                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
            this.halamanloading = true;
            await mainAPI5.get("parastapainnovationreffmonitoring-JenisPekerjaan?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datajenispekerjaan = [];
                        this.jenispekerjaan = [];
                        this.datajenispekerjaan = Response.data.content.data;
                        this.datajenispekerjaan.forEach((item) => {
                            this.jenispekerjaan.push({
                                label: item.nama,
                                code: this.datajenispekerjaan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedjenispekerjaan = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.jenispekerjaan.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedjenispekerjaan = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.jenispekerjaan.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }

                        this.datajenispekerjaan2 = [];
                        this.jenispekerjaan2 = [];
                        this.datajenispekerjaan2 = Response.data.content.data;
                        this.datajenispekerjaan2.forEach((item) => {
                            this.jenispekerjaan2.push({
                                label: item.nama,
                                code: this.datajenispekerjaan2.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedjenispekerjaan2 = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.jenispekerjaan2.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedjenispekerjaan2 = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.jenispekerjaan2.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        this.halamanloading = false;
                    }

                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
            this.halamanloading = true;
            await mainAPI5.get("parastapainnovationreffmonitoring-TahunProyek?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datatahunmulai = [];
                        this.tahunmulai = [];
                        this.datatahunmulai = Response.data.content.data;
                        this.datatahunmulai.forEach((item) => {
                            this.tahunmulai.push({
                                label: item.tahun,
                                code: this.datatahunmulai.indexOf(item) + 1,
                                tag: item.tahun,
                            });
                        });

                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedtahunmulai = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.tahunmulai.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedtahunmulai = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.tahunmulai.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }

                        this.datatahunmulai2 = [];
                        this.tahunmulai2 = [];
                        this.datatahunmulai2 = Response.data.content.data;
                        this.datatahunmulai2.forEach((item) => {
                            this.tahunmulai2.push({
                                label: item.tahun,
                                code: this.datatahunmulai2.indexOf(item) + 1,
                                tag: item.tahun,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedtahunmulai2 = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.tahunmulai2.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedtahunmulai2 = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.tahunmulai2.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }

                        this.datatahunselesai = [];
                        this.tahunselesai = [];
                        this.datatahunselesai = Response.data.content.data;
                        this.datatahunselesai.forEach((item) => {
                            this.tahunselesai.push({
                                label: item.tahun,
                                code: this.datatahunselesai.indexOf(item) + 1,
                                tag: item.tahun,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedtahunselesai = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.tahunselesai.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedtahunselesai = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.tahunselesai.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }

                        this.datatahunpersiapan = [];
                        this.tahunpersiapan = [];
                        this.datatahunpersiapan = Response.data.content.data;
                        this.datatahunpersiapan.forEach((item) => {
                            this.tahunpersiapan.push({
                                label: item.tahun,
                                code: this.datatahunpersiapan.indexOf(item) + 1,
                                tag: item.tahun,
                            });
                        });
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.defaultSelectedtahunpersiapan = {
                                code: 0,
                                label: 'Semua Data',
                                tag: '',
                            };
                            this.tahunpersiapan.unshift({
                                label: 'Semua Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        else {
                            this.defaultSelectedtahunpersiapan = {
                                code: 0,
                                label: 'All Data',
                                tag: '',
                            };
                            this.tahunpersiapan.unshift({
                                label: 'All Data',
                                code: 0,
                                tag: '',
                            });
                        }
                        this.halamanloading = false;
                    }

                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

        },
        onid_userChange(a) {
            try {
                this.selectedid_user = this.id_user[a].tag;
            }
            catch (err) {
                return;
            }
            this.ambildata();
        },
        onid_user2Change(a) {
            try {
                this.selectedid_user2 = this.id_user2[a].tag;
            }
            catch (err) {
                return;
            }
            this.ambildata();
        },
        ontahunmulaiChange(a) {
            try {
                this.selectedtahunmulai = this.tahunmulai[a].tag;
            }
            catch (err) {
                return;
            }
            this.ambildata();
        },
        ontahunmulai2Change(a) {
            try {
                this.selectedtahunmulai2 = this.tahunmulai2[a].tag;
            }
            catch (err) {
                return;
            }
            this.ambildata();
        },
        ontahunselesaiChange(a) {
            try {
                this.selectedtahunselesai = this.tahunselesai[a].tag;
            }
            catch (err) {
                return;
            }
            this.ambildata();
        },
        ontahunpersiapanChange(a) {
            try {
                this.selectedtahunpersiapan = this.tahunpersiapan[a].tag;
            }
            catch (err) {
                return;
            }
            this.ambildata();
        },
        onlokasiChange(a) {
            try {
                this.selectedlokasi = this.lokasi[a].tag;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedlokasi);
            this.ambildata();
        },
        onlokasi2Change(a) {
            try {
                this.selectedlokasi2 = this.lokasi2[a].tag;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedlokasi2);
            this.ambildata();
        },
        onjenispekerjaanChange(a) {
            try {
                this.selectedjenispekerjaan = this.jenispekerjaan[a].tag;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedjenispekerjaan)
            this.ambildata();

            //alert(this.selectedjenispekerjaan);
        },
        onjenispekerjaan2Change(a) {
            try {
                this.selectedjenispekerjaan2 = this.jenispekerjaan2[a].tag;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedjenispekerjaan2)
            this.ambildata();

            //alert(this.selectedjenispekerjaan2);
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            var paramurl = "";
            if ((this.iduser == null) || (this.iduser == 'null') || (this.iduser == '') || (this.iduser == undefined)) {
                paramurl = "parastapainnovationmonitoringpublik-QuickStatus?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.selectedid_user + "&id_lokasi=" + this.selectedlokasi + "&jenispekerjaan=" + this.selectedjenispekerjaan + "&tahunmulai=" + this.selectedtahunmulai + "&tahunselesai=" + this.selectedtahunselesai + "&tahunpersiapan=" + this.selectedtahunpersiapan;
            }
            else {
                paramurl = "parastapainnovationmonitoring-QuickStatus?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.selectedid_user + "&id_lokasi=" + this.selectedlokasi + "&jenispekerjaan=" + this.selectedjenispekerjaan + "&tahunmulai=" + this.selectedtahunmulai + "&tahunselesai=" + this.selectedtahunselesai + "&tahunpersiapan=" + this.selectedtahunpersiapan;
            }
            await mainAPI.get(paramurl).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        this.halamanloading = false;
                    }
                    else {
                        this.datapesan = '';
                        this.datamaster = [];
                        //alert(this.datapesan);
                        this.halamanloading = false;

                    }
                }
            ).catch(error => {
                this.datapesan = '';
                this.datamaster = [];
                this.datatahun = [];
                this.halamanloading = false;
            });
            this.halamanloading = true;
            await mainAPI.get("parastapainnovationmonitoringquick-QuickStatusKota?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.selectedid_user2 + "&id_lokasi=" + this.selectedlokasi2 + "&jenispekerjaan=" + this.selectedjenispekerjaan2 + "&tahunmulai=" + this.selectedtahunmulai2).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamasterkota = [];
                        this.datamasterkota = Response.data.content.data;
                        var namakota = [];
                        var jumlahkegiatan = [];
                        var sudahpersiapan = [];
                        var sudahttdkontrak = [];
                        var prosespelaksanaan = [];
                        var sudahpelaksanaan = [];

                        var penyiapanpersiapan = [];
                        var pengajuanpersiapan = [];
                        var reviewpersiapan = [];

                        var pengajuanprocurement = [];
                        var penyampaiannol = [];
                        var biddingdokumen = [];
                        var pengumumanlelang = [];
                        var evaluasi = [];
                        var pemenang = [];
                        var ttdkontrak = [];

                        for (let i = 0; i < this.datamasterkota.length; i++) {
                            this.halamanloading = true;
                            namakota.push(this.datamasterkota[i].Lokasi);
                            jumlahkegiatan.push(this.datamasterkota[i].Jumlah);
                            sudahpersiapan.push(this.datamasterkota[i].sudahpersiapan);
                            sudahttdkontrak.push(this.datamasterkota[i].sudahttdkontrak);
                            prosespelaksanaan.push(this.datamasterkota[i].prosespelaksanaan);
                            sudahpelaksanaan.push(this.datamasterkota[i].sudahpelaksanaan);

                            penyiapanpersiapan.push(this.datamasterkota[i].sudahpersiapan);
                            pengajuanpersiapan.push(this.datamasterkota[i].sudahpengajuan);
                            reviewpersiapan.push(this.datamasterkota[i].sudahreview);

                            pengajuanprocurement.push(this.datamasterkota[i].sudahpengajuanprocurement);
                            penyampaiannol.push(this.datamasterkota[i].sudahpenyampaiannolprocurement);
                            biddingdokumen.push(this.datamasterkota[i].sudahpengajuanbiddingdocument);
                            pengumumanlelang.push(this.datamasterkota[i].sudahpengumumanlelang);
                            evaluasi.push(this.datamasterkota[i].sudahevaluasilelang);
                            pemenang.push(this.datamasterkota[i].sudahpengumumanpemenang);
                            ttdkontrak.push(this.datamasterkota[i].sudahttdkontrak);
                        }
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.chartOptionsbar1 = {
                                title: {
                                    text: 'Jumlah Total Kegiatan Dan Tahapan Pekerjaan Per Lokasi',
                                    align: 'center'
                                },
                                xaxis: {
                                    categories: namakota,
                                },
                                yaxis: {
                                    title: {
                                        text: 'Jumlah Kegiatan'
                                    }
                                },
                            };
                        }
                        else {
                            this.chartOptionsbar1 = {
                                title: {
                                    text: 'Total Number of Activities and Work Stages Per Location',
                                    align: 'center'
                                },
                                xaxis: {
                                    categories: namakota,
                                },
                                yaxis: {
                                    title: {
                                        text: 'Number of Activities'
                                    }
                                },
                            };
                        }

                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.seriesbar1 = [{
                                name: 'Total Kegiatan',
                                data: jumlahkegiatan
                            }, {
                                name: 'Selesai Persiapan',
                                data: sudahpersiapan
                            }, {
                                name: 'Selesai Pengadaan',
                                data: sudahttdkontrak
                            }, {
                                name: 'Implementasi',
                                data: prosespelaksanaan
                            }, {
                                name: 'Selesai Implementasi',
                                data: sudahpelaksanaan
                            }]
                        }
                        else {
                            this.seriesbar1 = [{
                                name: 'Total Kegiatan',
                                data: jumlahkegiatan
                            }, {
                                name: 'Selesai Persiapan',
                                data: sudahpersiapan
                            }, {
                                name: 'Selesai Pengadaan',
                                data: sudahttdkontrak
                            }, {
                                name: 'Implementasi',
                                data: prosespelaksanaan
                            }, {
                                name: 'Selesai Implementasi',
                                data: sudahpelaksanaan
                            }]
                        }
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.chartOptionsbar2 = {
                                title: {
                                    text: 'Jumlah Total Kegiatan Dan Tahapan Pekerjaan Per Lokasi',
                                    align: 'center'
                                },
                                xaxis: {
                                    categories: namakota,
                                },
                                yaxis: {
                                    title: {
                                        text: 'Jumlah Kegiatan'
                                    }
                                },
                            };
                        }
                        else {
                            this.chartOptionsbar2 = {
                                title: {
                                    text: 'Total Number of Activities and Work Preparation Stages Per Location',
                                    align: 'center'
                                },
                                xaxis: {
                                    categories: namakota,
                                },
                                yaxis: {
                                    title: {
                                        text: 'Number of Activities'
                                    }
                                },
                            };
                        }
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.seriesbar2 = [{
                                name: 'Total Kegiatan',
                                data: jumlahkegiatan
                            }, {
                                name: 'Penyiapan Dokumen Pengadaan',
                                data: penyiapanpersiapan
                            }, {
                                name: 'Pengajuan Dokumen Pengadaan',
                                data: pengajuanpersiapan
                            }, {
                                name: 'Review Dokumen Pengadaan',
                                data: reviewpersiapan
                            }]
                        }
                        else {
                            this.seriesbar2 = [{
                                name: 'Total Activities',
                                data: jumlahkegiatan
                            }, {
                                name: 'Preparation of Procurement Documents',
                                data: penyiapanpersiapan
                            }, {
                                name: 'Submission of Procurement Documents',
                                data: pengajuanpersiapan
                            }, {
                                name: 'Review of Procurement Documents',
                                data: reviewpersiapan
                            }]

                        }

                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.chartOptionsbar3 = {
                                title: {
                                    text: 'Jumlah Total Kegiatan Dan Tahapan Pengadaan Pekerjaan Per Lokasi',
                                    align: 'center'
                                },
                                xaxis: {
                                    categories: namakota,
                                },
                                yaxis: {
                                    title: {
                                        text: 'Jumlah Kegiatan'
                                    }
                                },
                            };
                        }
                        else {
                            this.chartOptionsbar3 = {
                                title: {
                                    text: 'Total Number of Activities and Stages of Work Procurement Per Location',
                                    align: 'center'
                                },
                                xaxis: {
                                    categories: namakota,
                                },
                                yaxis: {
                                    title: {
                                        text: 'Number of Activities'
                                    }
                                },
                            };
                        }

                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.seriesbar3 = [{
                                name: 'Total Kegiatan',
                                data: jumlahkegiatan
                            }, {
                                name: 'Penyampaian NOL untuk Procurement Plan',
                                data: penyampaiannol
                            }, {
                                name: 'Pengajuan KAK/Spesifikasi Teknis',
                                data: pengajuanprocurement
                            }, {
                                name: 'Pengajuan Bidding Document',
                                data: biddingdokumen
                            }, {
                                name: 'Pengumuman Lelang',
                                data: pengumumanlelang
                            }, {
                                name: 'Evaluasi',
                                data: evaluasi
                            }, {
                                name: 'Pengumuman Pemenang/ Letter Acceptance',
                                data: pemenang
                            }, {
                                name: 'Sign Contract',
                                data: ttdkontrak
                            }]
                        }
                        else {
                            this.seriesbar3 = [{
                                name: 'Total Activities',
                                data: jumlahkegiatan
                            }, {
                                name: 'Submission of NOL for Procurement Plan',
                                data: penyampaiannol
                            }, {
                                name: 'Submission of TOR/Technical Specifications',
                                data: pengajuanprocurement
                            }, {
                                name: 'Submission of Bidding Documents',
                                data: biddingdokumen
                            }, {
                                name: 'Auction Announcement',
                                data: pengumumanlelang
                            }, {
                                name: 'Evaluation',
                                data: evaluasi
                            }, {
                                name: 'Letter Acceptance',
                                data: pemenang
                            }, {
                                name: 'Sign Contract',
                                data: ttdkontrak
                            }]
                        }
                        this.halamanloading = false;
                    }
                    else {
                        this.datapesan = '';
                        this.datamasterkota = [];
                        //alert(this.datapesan);
                        this.halamanloading = false;

                    }
                }
            ).catch(error => {
                this.datapesan = '';
                this.datamasterkota = [];
                this.datatahun = [];
                this.halamanloading = false;
            });


        },
    },
    mounted() {
        this.halamanloading = true;
        this.ambildatareff();
        this.ambildata();
    },
}
</script>

<style></style>